module.exports = __webpack_public_path__ + "media/images/logo_dashboard-e08dcc66c057a9485789745f13a0c040.png";